import React from 'react';
import { TooltipTableCell } from '../TooltipTableCell';

export const ResponsableWithTooltip = {
    Header: () => 'Responsable',
    id: 'responsable',
    accessor: row => row?.responsable?.name,  // ← valor para ordenar
    Cell: ({ row }) => (
        <TooltipTableCell
            label={row.original.responsable?.name}
            tooltipText={row.original.responsable?.email}
            emptyText="SIN ASIGNAR"
        />
    ),
};
